import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import type { ReactNode } from "react";

export function DataState({
    loading,
    error,
    empty,
    emptyTitle = "Nada por aqui",
    emptyText = "Nenhum registro encontrado.",
    onRetry,
    children,
}: {
    loading?: boolean;
    error?: string;
    empty?: boolean;
    emptyTitle?: string;
    emptyText?: string;
    onRetry?: () => void;
    children?: ReactNode;
}) {
    if (loading)
        return (
            <div className="data-state">
                <ProgressSpinner strokeWidth="4" />
                <strong>Carregando informações…</strong>
            </div>
        );
    if (error)
        return (
            <div className="data-state error">
                <i className="pi pi-wifi" />
                <strong>Falha ao carregar</strong>
                <p>{error}</p>
                {onRetry ? <Button label="Tentar novamente" icon="pi pi-refresh" outlined onClick={onRetry} /> : null}
            </div>
        );
    if (empty)
        return (
            <div className="data-state">
                <i className="pi pi-inbox" />
                <strong>{emptyTitle}</strong>
                <p>{emptyText}</p>
            </div>
        );
    return children ?? null;
}
